<template>
    <el-dialog
        title="供应商评分表"
        class="key-data-trans-legal-dialog"
        :append-to-body="true"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!confirmLoading && !pdfTransforming"
        ref="dialogRef"
        width="98%"
        top="3vh"
        :before-close="close"
    >
        <div v-loading="loading" class="content-wrap" ref="contentRef">
            <div class="title-container">
                <span class="title">供应商基础信息</span>
            </div>
            <BaseInfo ref="biRef" :pdfTransforming="pdfTransforming" type="warehouse" />
            <div class="title-container">
                <span class="title">资质和合规信息</span>
            </div>
            <el-table :data="qlfTableData" :span-method="arraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
                <el-table-column prop="propertyNature" label="主体性质" width="120"></el-table-column>
                <el-table-column prop="zzlx" label="资质类型">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.zzlx }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.qualificationFlag" label="符合">符合</el-radio>
                        <el-radio v-model="scope.row.qualificationFlag" label="不符合">不符合</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sm" label="说明"></el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="title-container">
                <span class="title">能力评估</span>
                <div class="sub-title">1、运营能力及经验</div>
            </div>
            <el-table :data="operationTableData" :span-method="opArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="200"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.pfbz }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">2、安全管理</div>
            <el-table :data="riskTableData" :span-method="riArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="170"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准"></el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">3、其他</div>
            <el-table :data="serviceTableData" :span-method="svArraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="pgwd" label="评估维度" width="120"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准"></el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="require-title">评审要求</div>
            <div class="require-rule margin-bottom-20">1、评审规则：资质信息任一项不符合不得引入；运营能力及经验、安全管理总得分低于该项总分80%不得引入。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="confirmLoading || pdfTransforming" @click="close">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading || pdfTransforming" @click="confirm">确认提交</el-button>
            <!-- <el-button @click="generateAndUploadPDF('供应商评分表-运输【法人】.pdf')">生成PDF并上传</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js'
import BaseInfo from './BaseInfo.vue'
import scoreMixin from './scoreMixin.js';
import { onlineDetail, onlineSave } from '../../../../../../api/qualification.js';

// SRM_BASIC_QUALITY 供应商评分表-仓储-仓库管理
const TYPE = '40'

const INIT_QT = [
    { businessType: '仓储', propertyNature: '法人', zzlx: '营业执照法人身份证股东信息登记表', qualificationFlag: '', sm: '原则上此项中任何一条不符合不得引入。有特殊需求需走供应商特批引入。', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '一般纳税人，成立年限一年及以上，注册资金超过100万元，开具6%的仓储服务业增值税专用发票', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '具有类似产品的仓储管理经验且有现成在运行的仓储管理项目（提供合同扫描件）', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '能够接受我司转编人员及现有资产设备，仓储管理制度及管理体系完善', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '是否符合分权手册，不符要求但需引入的需走特批流程', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '廉洁要求：\n是否存在违反A类禁令仓库，黑名单、内部员工关联关系、美的离职员工、退出未满一年等限制性供应商，不得引入；', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '廉洁要求：\n必须提供集团亲属关系盖章表，无盖章表或无法说明原因者不得引入', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '信息准确性：\n登录“天眼查”，查询是否存在被强制执行、纳入失信名单、重大风险项；', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '信息准确性：\nSRM系统系统信息与实际资质证件不一致', qualificationFlag: '', sm: '', resultFlag: '' },
]

const INIT_OT = [
    { pgwd: '同品类现有仓库管理运作规模（客户/面积/合同/结算清单等）', pfbz: '1、有经验\n1万平米以下6分；1-2万平米7分；2-5万平米以上10分,5万平米以上20分；\n2、无同品类但有运作经验\n3万平米以下7分，3万平米以上10分；', zf: '20', df: '', resultFlag: '' },
    { pgwd: '仓库管理团队经验', pfbz: '1、有当地仓库管理经验3-5年，且提供家电行业（3PL为相关行业）：15分；\n2、有当地仓库管理经验3-5年 8分\n3、有当地仓库管理经验1-2年：5分；\n4、无当地但有其他区域仓库管理经验：0分', zf: '15', df: '', resultFlag: '' },
    { pgwd: '仓储管理团队数量及结构', pfbz: '1、公司仓库人员数量（5分）\n10-20人1分；20-50人2分；50-100人3分；100人以上5分；\n2、当地核心团队经验，含：项目负责人、核算主管、仓储主管（5分）\n人均1-2年1分；人均2-5年3分；人均5年以上5分；\n3、当地新老员工比例（5分）\n1年以下占比＞50%1分；1-2年占比＞50%2分；2-5年年占比＞50%5分', zf: '15', df: '', resultFlag: '' },
    { pgwd: '仓储管理相关制度文件', pfbz: '有行业体系文件：出入库管理、账务管理、现场管理、品质服务、在库管理、非正品管理、培训、sop等\n1-4个3分；5个以上（含5个）6分', zf: '6', df: '', resultFlag: '' },
    { pgwd: '账务处理', pfbz: '账账一致，账实一致性（盘点抽查）', zf: '5', df: '', resultFlag: '' },
    { pgwd: '库位管理', pfbz: '库位是否会根据产品型号配置存卡；', zf: '2', df: '', resultFlag: '' },
    { pgwd: '出入库管理', pfbz: '历史是否有库存管理经验，每点3分\n① 先入先出；② 定期盘点；③入库产品分类；', zf: '6', df: '', resultFlag: '' },
    { pgwd: '产品码放', pfbz: '1、有产品码放标准的概念，每点得3分\n①产品不能倒置、侧放；不能超高、产品超出托盘单边10cm；② 部分产品隔离放置；③按库位线码放整齐,不能存在倾斜，地台板存放的产品各跺产品间隔10cm以上，不能堵塞通道；④ 使用不合格地台板、双层堆码时单面板需用垫垫板', zf: '12', df: '', resultFlag: '' },
    { pgwd: '非正品管理', pfbz: '是否有非正品与正品分区、分类管理，非正品是否有明显标识或及时挑出的管理经验', zf: '3', df: '', resultFlag: '' },
    { pgwd: '作业设备管理', pfbz: '是否有设备管理的经验，了解设备的参数、日常检查及维护经验', zf: '4', df: '', resultFlag: '' },
]
const INIT_RT = [
    { pgwd: '重大事故发生', pfbz: '近3年仓库管理项目中无重大火灾事故，无重大品质事故', zf: '7', df: '', resultFlag: '' },
    { pgwd: '作业安全', pfbz: '1、现场作业员工全员均已足额购买工伤险或相应商业保险；', zf: '3', df: '', resultFlag: '' },
    { pgwd: '制度稽查与应用（1）', pfbz: '是否有考核应用记录等', zf: '2', df: '', resultFlag: '' },
]
const INIT_ST = [
    { pgwd: '创新方案（加分项5）', pfbz: '是否有优秀痛点解决方案提供并可实施（例如库位规划、系统对接方案、痛点解决方案等）', zf: '7', df: '', resultFlag: '' },
]

export default {
    components: { BaseInfo },
    mixins: [scoreMixin],
    data() {
        return {
            // SRM_YES,
            // currentId: null,
            // currentVersion: null,
            currentRow: null,
            visible: false,
            loading: false,
            confirmLoading: false,
            // pdfTransforming: false,

            qlfTableData: JSON.parse(JSON.stringify(INIT_QT)),
            operationTableData: JSON.parse(JSON.stringify(INIT_OT)),
            riskTableData: JSON.parse(JSON.stringify(INIT_RT)),
            serviceTableData: JSON.parse(JSON.stringify(INIT_ST)),
        };
    },
    methods: {
        open(row) {
            this.currentRow = row
            this.setUploadQlfForm(row)
            this.visible = true
            this.loading = true
            onlineDetail({ supplierCode: row.qualificationTypeCode, id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data, JSON.parse(res.data.onlineContent || null))
                }
            }).finally(() => { this.loading = false })
        },
        close() {
            this.visible = false
            this.$refs.biRef.reset()
            this.qlfTableData = JSON.parse(JSON.stringify(INIT_QT))
            this.operationTableData = JSON.parse(JSON.stringify(INIT_OT))
            this.riskTableData = JSON.parse(JSON.stringify(INIT_RT))
            this.serviceTableData = JSON.parse(JSON.stringify(INIT_ST))
        },
        setData(baseInfo, data) {
            this.$refs.biRef.setBaseInfo(baseInfo)
            if (!data) {
                return false
            }
            this.$refs.biRef.setFormData(data.supplierInfo)
            this.qlfTableData[0].resultFlag = data.supplierQualification.resultFlag
            this.qlfTableData.forEach((item, index) => {
                item.qualificationFlag = data.supplierQualification['qualification' + (index + 1) + 'Flag']
            })
            this.operationTableData[0].resultFlag = data.operationalCapability.resultFlag
            this.operationTableData.forEach((item, index) => {
                item.df = data.operationalCapability['risk' + (index + 1) + 'Score']
            })
            this.riskTableData[0].resultFlag = data.safetyManagerment.resultFlag
            this.riskTableData.forEach((item, index) => {
                item.df = data.safetyManagerment['safety' + (index + 1) + 'Score']
            })
            this.serviceTableData[0].resultFlag = data.otherInfo.resultFlag
            this.serviceTableData.forEach((item, index) => {
                item.df = data.otherInfo['add' + (index + 1) + 'Score']
            })
        },
        confirm() {
            const supplierInfo = this.$refs.biRef.getData()
            // 资质信息-是否符合-必填校验
            const qlfValid = this.qlfTableData.every(item => !!item.qualificationFlag)
            const scoreValid = this.scoreValidate()
            if (supplierInfo && qlfValid && scoreValid) {
                this.generateAndUploadPDF(this.currentRow.qualificationName + '.pdf', () => {
                    this.confirmLoading = true
                    onlineSave(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!')
                            this.$emit('submit', this.getParamsFromUpload())
                            this.close()
                        }
                    }).finally(() => { this.confirmLoading = false })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请输入必填信息，字长不能超过20位(通讯地址100位)，得分列请输入0或正整数!',
                    duration: 4000,
                })
            }
        },
        // 所有得分项格式校验
        scoreValidate() {
            const oError = this.operationTableData.some(item => this.scoreError(item.df, item.zf))
            const rError = this.riskTableData.some(item => this.scoreError(item.df, item.zf))
            const sError = this.serviceTableData.some((item, index) => this.scoreError(item.df, item.zf))
            return !oError && !rError && !sError
        },
        getParams() {
            const params = {
                type: TYPE,
                onlineContent: '',
                ...this.getParamsFromUpload()
            }
            const supplierInfo = this.$refs.biRef.getData()
            const supplierQualification = {
                resultFlag: this.qlfTableData[0].resultFlag,
            }
            this.qlfTableData.forEach((item, index) => {
                supplierQualification['qualification' + (index + 1) + 'Flag'] = item.qualificationFlag
            })
            const operationalCapability = {
                resultFlag: this.operationTableData[0].resultFlag,
            }
            this.operationTableData.forEach((item, index) => {
                operationalCapability['risk' + (index + 1) + 'Score'] = item.df
            })
            const safetyManagerment = {
                resultFlag: this.riskTableData[0].resultFlag,
            }
            this.riskTableData.forEach((item, index) => {
                safetyManagerment['safety' + (index + 1) + 'Score'] = item.df
            })
            const otherInfo = {
                resultFlag: this.serviceTableData[0].resultFlag,
            }
            this.serviceTableData.forEach((item, index) => {
                otherInfo['add' + (index + 1) + 'Score'] = item.df
            })
            params.onlineContent = JSON.stringify({ supplierInfo, supplierQualification, operationalCapability, safetyManagerment, otherInfo })
            return params
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 1, 4, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [9, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        opArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [10, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        riArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [3, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        svArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 5) {
                if (rowIndex === 0) {
                    return [3, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        isError(val) {
            return ['', null, undefined].includes(val)
        },
        scoreError(score, max) {
            // 非0或正整数 || 大于最大值
            return !/^\+?[0-9][0-9]*$/.test(score) || Number(score) > Number(max)
        },
    },
    watch: {
        qlfTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => !item.qualificationFlag || item.qualificationFlag === '不符合') ? '不通过' : '通过'
            },
            deep: true,
        },
        operationTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                
                const total = val.reduce((t,v) => {
                    t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                    t.zf += Number(v.zf)
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = total.df >= Decimal.mul(total.zf, 0.8).toNumber() ? '通过' : '不通过'
            },
            deep: true,
        },
        riskTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                const total = val.reduce((t,v) => {
                    t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                    t.zf += Number(v.zf)
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = total.df >= Decimal.mul(total.zf, 0.8).toNumber() ? '通过' : '不通过'
            },
            deep: true,
        },
        serviceTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                const total = val.reduce((t,v) => {
                    t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                    t.zf += Number(v.zf)
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = total.df >= Decimal.mul(total.zf, 0.8).toNumber() ? '通过' : '不通过'
            },
            deep: true,
        },
    },
}
</script>
<style lang="less">
.key-data-trans-legal-dialog {
    .el-dialog {
        margin-bottom: 0;
    }

    .el-dialog__body {
        overflow-y: scroll;
        padding: 0;
        height: calc(94vh - 113px);
        box-sizing: border-box;
    }

    .content-wrap {
        padding: 16px;
    }

    .title-container {
        // margin-bottom: 5px;
        font-size: 16px;
        color: #000;

        // i {
        //     float: right;
        //     padding-right: 10px;
        //     font-size: 24px;
        //     cursor: pointer;
        // }
    }

    .title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .sub-title {
        padding: 5px 10px;
        font-size: 14px;
        color: #000;
        background-color: #f2f2f2;
    }

    .el-table {
        // border-right: 1px solid #ebeef5;

        .cell {
            white-space: normal;
        }

        .header-bg th {
            background: #f5f7fa;
        }
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .require-title {
        font-size: 16px;
        color: #000;
    }

    .el-dialog__footer {
        padding-top: 15px;
        padding-bottom: 15px;
        text-align: center;
        border-top: 1px solid #d7d7d7;

        .el-button + .el-button {
            margin-left: 30px;
        }
    }

    .required {
        color: #f96c5f;
    }

    .is-error input {
        border-color: #f96c5f;
    }
}
</style>